function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("rect", {
  width: 298,
  height: 80,
  fill: "#FC0000",
  rx: 10
}), React.createElement("path", {
  fill: "#8A0000",
  d: "M0,56 L298,56 L298,72 C298,77.5228475 293.522847,82 288,82 L10,82 C4.4771525,82 6.76353751e-16,77.5228475 0,72 L0,56 Z"
}), React.createElement("path", {
  fill: "#9D0000",
  fillOpacity: .4,
  d: "M10,0 L55,0 L55,26 L0,26 L0,10 C-6.76353751e-16,4.4771525 4.4771525,1.01453063e-15 10,0 Z"
}), React.createElement("polygon", {
  fill: "#B90000",
  points: "0 26 54.633 26 54.633 21 104.3 21 104.3 11 193.7 11 193.7 21 248.333 21 248.333 26 298 26 298 56 0 56"
}), React.createElement("rect", {
  width: 35,
  height: 15,
  x: 109,
  y: 15,
  fill: "#000",
  fillOpacity: .5,
  rx: 7.5
}), React.createElement("rect", {
  width: 41,
  height: 15,
  x: 130,
  y: 35,
  fill: "#000",
  fillOpacity: .5,
  rx: 7.5
}), React.createElement("rect", {
  width: 50,
  height: 15,
  x: 124,
  y: 60,
  fill: "#000",
  fillOpacity: .5,
  rx: 7.5
}), React.createElement("rect", {
  width: 41,
  height: 15,
  x: 253,
  y: 35,
  fill: "#000",
  fillOpacity: .5,
  rx: 7.5
}), React.createElement("rect", {
  width: 41,
  height: 15,
  x: 253,
  y: 60,
  fill: "#000",
  fillOpacity: .5,
  rx: 7.5
}), React.createElement("rect", {
  width: 41,
  height: 15,
  x: 5,
  y: 35,
  fill: "#000",
  fillOpacity: .5,
  rx: 7.5
}), React.createElement("rect", {
  width: 41,
  height: 15,
  x: 5,
  y: 60,
  fill: "#000",
  fillOpacity: .5,
  rx: 7.5
}), React.createElement("rect", {
  width: 20,
  height: 15,
  x: 100,
  y: 35,
  fill: "#000",
  fillOpacity: .5,
  rx: 7.5
}), React.createElement("rect", {
  width: 20,
  height: 15,
  x: 100,
  y: 60,
  fill: "#000",
  fillOpacity: .5,
  rx: 7.5
}), React.createElement("rect", {
  width: 20,
  height: 15,
  x: 70,
  y: 35,
  fill: "#000",
  fillOpacity: .5,
  rx: 7.5
}), React.createElement("rect", {
  width: 20,
  height: 15,
  x: 70,
  y: 60,
  fill: "#000",
  fillOpacity: .5,
  rx: 7.5
}), React.createElement("rect", {
  width: 15,
  height: 15,
  x: 50,
  y: 35,
  fill: "#000",
  fillOpacity: .5,
  rx: 7.5
}), React.createElement("rect", {
  width: 15,
  height: 15,
  x: 50,
  y: 60,
  fill: "#000",
  fillOpacity: .5,
  rx: 7.5
}), React.createElement("rect", {
  width: 20,
  height: 15,
  x: 179,
  y: 35,
  fill: "#000",
  fillOpacity: .5,
  rx: 7.5
}), React.createElement("rect", {
  width: 20,
  height: 15,
  x: 179,
  y: 60,
  fill: "#000",
  fillOpacity: .5,
  rx: 7.5
}), React.createElement("rect", {
  width: 20,
  height: 15,
  x: 209,
  y: 35,
  fill: "#000",
  fillOpacity: .5,
  rx: 7.5
}), React.createElement("rect", {
  width: 20,
  height: 15,
  x: 209,
  y: 60,
  fill: "#000",
  fillOpacity: .5,
  rx: 7.5
}), React.createElement("rect", {
  width: 15,
  height: 15,
  x: 234,
  y: 35,
  fill: "#000",
  fillOpacity: .5,
  rx: 7.5
}), React.createElement("rect", {
  width: 15,
  height: 15,
  x: 234,
  y: 60,
  fill: "#000",
  fillOpacity: .5,
  rx: 7.5
}), React.createElement("rect", {
  width: 35,
  height: 15,
  x: 154,
  y: 15,
  fill: "#000",
  fillOpacity: .5,
  rx: 7.5
}), React.createElement("path", {
  fill: "#9D0000",
  fillOpacity: .4,
  d: "M248,0 L288,0 C293.522847,-1.01453063e-15 298,4.4771525 298,10 L298,26 L248,26 L248,0 Z"
}), React.createElement("rect", {
  width: 55,
  height: 21,
  x: 194,
  fill: "#C30000",
  fillOpacity: .4
}), React.createElement("rect", {
  width: 50,
  height: 21,
  x: 54,
  fill: "#C30000",
  fillOpacity: .4
}), React.createElement("rect", {
  width: 89,
  height: 11,
  x: 104,
  fill: "#FC0000",
  fillOpacity: .4
}), React.createElement("g", {
  transform: "translate(253 34)"
}, React.createElement("path", {
  fill: "#E5CFA4",
  d: "M8.80361926,28.1784385 L41.0583022,31.4039068 C43.2308321,31.6211598 44.827789,33.5404138 44.6464703,35.7162375 L42.0371794,67.0277286 C41.9949194,67.5348485 41.8562822,68.029247 41.6287051,68.4844011 L38.4175155,74.9067803 C38.1257424,75.4903265 37.981137,76.1363847 37.9963055,76.7886328 L39.8638585,157.093411 C39.9152199,159.301952 38.1664797,161.133966 35.9579378,161.185327 C35.7428692,161.190329 35.5277476,161.177972 35.3146662,161.148378 L7.56465852,157.29421 C5.52670133,157.01116 4.03589315,155.228244 4.11812817,153.172369 L6.93989372,82.6282299 C6.96186661,82.0789077 6.87036757,81.530953 6.67110857,81.0185727 L0.915879182,66.2194114 C0.297713936,64.6298436 0.0963753183,62.9085856 0.331003166,61.2192651 L4.44363529,31.6083138 C4.73933676,29.4792633 6.66479947,27.9645566 8.80361926,28.1784385 Z"
}), React.createElement("g", {
  fillRule: "nonzero",
  transform: "translate(2)"
}, React.createElement("path", {
  fill: "#ECD8B1",
  d: "M3 16C3 13.5147186 5.01471863 11.5 7.5 11.5 9.98528137 11.5 12 13.5147186 12 16L12 30.5C12 32.9852814 9.98528137 35 7.5 35 5.01471863 35 3 32.9852814 3 30.5L3 16zM13.007329 13.2567241C12.8655442 10.7754904 14.7620423 8.64911378 17.2432759 8.507329 19.7245096 8.36554421 21.8508862 10.2620423 21.992671 12.7432759L22.992671 30.2432759C23.1344558 32.7245096 21.2379577 34.8508862 18.7567241 34.992671 16.2754904 35.1344558 14.1491138 33.2379577 14.007329 30.7567241L13.007329 13.2567241zM23.007329 13.2567241C22.8655442 10.7754904 24.7620423 8.64911378 27.2432759 8.507329 29.7245096 8.36554421 31.8508862 10.2620423 31.992671 12.7432759L32.992671 30.2432759C33.1344558 32.7245096 31.2379577 34.8508862 28.7567241 34.992671 26.2754904 35.1344558 24.1491138 33.2379577 24.007329 30.7567241L23.007329 13.2567241zM35 17.5C35 15.290861 36.790861 13.5 39 13.5 41.209139 13.5 43 15.290861 43 17.5L43 33.5C43 35.709139 41.209139 37.5 39 37.5 36.790861 37.5 35 35.709139 35 33.5L35 17.5z"
}), React.createElement("path", {
  fill: "#F5E7CB",
  d: "M.704840099 8.34223747C-.036457186 5.97008616 1.28561122 3.44613738 3.65776253 2.7048401 6.02991384 1.96354281 8.55386262 3.28561122 9.2951599 5.65776253L11.7951599 13.6577625C12.5364572 16.0299138 11.2143888 18.5538626 8.84223747 19.2951599 6.47008616 20.0364572 3.94613738 18.7143888 3.2048401 16.3422375L.704840099 8.34223747zM10.7048401 6.34223747C9.96354281 3.97008616 11.2856112 1.44613738 13.6577625.704840099 16.0299138-.036457186 18.5538626 1.28561122 19.2951599 3.65776253L21.7951599 11.6577625C22.5364572 14.0299138 21.2143888 16.5538626 18.8422375 17.2951599 16.4700862 18.0364572 13.9461374 16.7143888 13.2048401 14.3422375L10.7048401 6.34223747zM20.7048401 6.34223747C19.9635428 3.97008616 21.2856112 1.44613738 23.6577625.704840099 26.0299138-.036457186 28.5538626 1.28561122 29.2951599 3.65776253L31.7951599 11.6577625C32.5364572 14.0299138 31.2143888 16.5538626 28.8422375 17.2951599 26.4700862 18.0364572 23.9461374 16.7143888 23.2048401 14.3422375L20.7048401 6.34223747zM32.1820801 9.19309997C31.5231492 7.08452103 32.6983211 4.84101101 34.8069 4.18208009 36.915479 3.52314917 39.158989 4.69832108 39.8179199 6.80690003L42.3179199 14.8069C42.9768508 16.915479 41.8016789 19.158989 39.6931 19.8179199 37.584521 20.4768508 35.341011 19.3016789 34.6820801 17.1931L32.1820801 9.19309997z"
}))), React.createElement("g", {
  transform: "matrix(-1 0 0 1 48 36)"
}, React.createElement("path", {
  fill: "#E5CFA4",
  d: "M8.80361926,28.1784385 L41.0583022,31.4039068 C43.2308321,31.6211598 44.827789,33.5404138 44.6464703,35.7162375 L42.0371794,67.0277286 C41.9949194,67.5348485 41.8562822,68.029247 41.6287051,68.4844011 L38.4175155,74.9067803 C38.1257424,75.4903265 37.981137,76.1363847 37.9963055,76.7886328 L39.8638585,157.093411 C39.9152199,159.301952 38.1664797,161.133966 35.9579378,161.185327 C35.7428692,161.190329 35.5277476,161.177972 35.3146662,161.148378 L7.56465852,157.29421 C5.52670133,157.01116 4.03589315,155.228244 4.11812817,153.172369 L6.93989372,82.6282299 C6.96186661,82.0789077 6.87036757,81.530953 6.67110857,81.0185727 L0.915879182,66.2194114 C0.297713936,64.6298436 0.0963753183,62.9085856 0.331003166,61.2192651 L4.44363529,31.6083138 C4.73933676,29.4792633 6.66479947,27.9645566 8.80361926,28.1784385 Z"
}), React.createElement("g", {
  fillRule: "nonzero",
  transform: "translate(2)"
}, React.createElement("path", {
  fill: "#ECD8B1",
  d: "M3 16C3 13.5147186 5.01471863 11.5 7.5 11.5 9.98528137 11.5 12 13.5147186 12 16L12 30.5C12 32.9852814 9.98528137 35 7.5 35 5.01471863 35 3 32.9852814 3 30.5L3 16zM13.007329 13.2567241C12.8655442 10.7754904 14.7620423 8.64911378 17.2432759 8.507329 19.7245096 8.36554421 21.8508862 10.2620423 21.992671 12.7432759L22.992671 30.2432759C23.1344558 32.7245096 21.2379577 34.8508862 18.7567241 34.992671 16.2754904 35.1344558 14.1491138 33.2379577 14.007329 30.7567241L13.007329 13.2567241zM23.007329 13.2567241C22.8655442 10.7754904 24.7620423 8.64911378 27.2432759 8.507329 29.7245096 8.36554421 31.8508862 10.2620423 31.992671 12.7432759L32.992671 30.2432759C33.1344558 32.7245096 31.2379577 34.8508862 28.7567241 34.992671 26.2754904 35.1344558 24.1491138 33.2379577 24.007329 30.7567241L23.007329 13.2567241zM35 17.5C35 15.290861 36.790861 13.5 39 13.5 41.209139 13.5 43 15.290861 43 17.5L43 33.5C43 35.709139 41.209139 37.5 39 37.5 36.790861 37.5 35 35.709139 35 33.5L35 17.5z"
}), React.createElement("path", {
  fill: "#F5E7CB",
  d: "M.704840099 8.34223747C-.036457186 5.97008616 1.28561122 3.44613738 3.65776253 2.7048401 6.02991384 1.96354281 8.55386262 3.28561122 9.2951599 5.65776253L11.7951599 13.6577625C12.5364572 16.0299138 11.2143888 18.5538626 8.84223747 19.2951599 6.47008616 20.0364572 3.94613738 18.7143888 3.2048401 16.3422375L.704840099 8.34223747zM10.7048401 6.34223747C9.96354281 3.97008616 11.2856112 1.44613738 13.6577625.704840099 16.0299138-.036457186 18.5538626 1.28561122 19.2951599 3.65776253L21.7951599 11.6577625C22.5364572 14.0299138 21.2143888 16.5538626 18.8422375 17.2951599 16.4700862 18.0364572 13.9461374 16.7143888 13.2048401 14.3422375L10.7048401 6.34223747zM20.7048401 6.34223747C19.9635428 3.97008616 21.2856112 1.44613738 23.6577625.704840099 26.0299138-.036457186 28.5538626 1.28561122 29.2951599 3.65776253L31.7951599 11.6577625C32.5364572 14.0299138 31.2143888 16.5538626 28.8422375 17.2951599 26.4700862 18.0364572 23.9461374 16.7143888 23.2048401 14.3422375L20.7048401 6.34223747zM32.1820801 9.19309997C31.5231492 7.08452103 32.6983211 4.84101101 34.8069 4.18208009 36.915479 3.52314917 39.158989 4.69832108 39.8179199 6.80690003L42.3179199 14.8069C42.9768508 16.915479 41.8016789 19.158989 39.6931 19.8179199 37.584521 20.4768508 35.341011 19.3016789 34.6820801 17.1931L32.1820801 9.19309997z"
}))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 298,
    height: 198,
    viewBox: "0 0 298 198"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/beastmakerHang.4e46c7fb.svg";
export { SvgComponent as ReactComponent };